module.exports = __webpack_public_path__ + "static/HR Portal Meine Daten Dossier Lohnabrechnung-6afcdb258e832b671b66716b8f7a2ffa.jpg";